import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        nav: {
          home: "Home",
          about: "About",
          services: "Services",
          contact: "Contact",
          language: "EN | AR",
        },
        hero:{
            title:"Engineering solutions in construction, architecture, mechanical, and electrical."
        },

 inbox: {
    "location": "Location",
    "locationContent": "Al Muraba, Riyadh, Saudi Arabia",
    "whatsapp": "WhatsApp",
    "whatsappContent": "+966582044542",
    "phone": "Phone",
    "phoneContent": "011 4883449"
  },


about: {
    "sectionTitle": "Who are we?",
    "companyName": "Turath Consultant | Your Trusted Partner in Engineering and Design",
    "paragraph1": "Turath Consultant is a leading multidisciplinary engineering consultancy based in Riyadh. We specialize in delivering high-quality solutions in:",
    "servicesList": [
      "• Construction consultancy",
      "• Architectural and structural design",
      "• Mechanical and electrical (MEP) engineering"
    ],
    "paragraph2": "With a strong commitment to innovation, quality, and precision, we support private clients, real estate developers, and public sector institutions from concept to completion.",
    "paragraph3": "Our experienced team is passionate about creating sustainable, efficient, and visionary environments that shape the future of modern living.",
    "feature1Title": "Multidisciplinary Expertise",
    "feature1Subtitle": "Architecture, construction, MEP, and structural design—all under one roof.",
    "feature2Title": "Client-Focused Solutions",
    "feature2Subtitle": "Tailored designs that blend innovation, functionality, and sustainability.",
    "feature3Title": "Our Future Vision",
    "feature3Subtitle": "Driving innovation and sustainability to shape tomorrow's smart cities.",
    "stat1Label": "Client Satisfaction",
    "stat2Label": "Completed Projects",
    "stat3Label": "Years of Expertise"
  },



  services: {
    "title": "Our Specialized Services in Engineering Consulting",
    "subtitle": "We provide integrated engineering solutions with international standards and local expertise.",
    "button": "Service Request",
    "construction": {
      "title": "Construction Services",
      "description": "We provide comprehensive construction solutions from planning to execution with quality and safety standards."
    },
    "constructionItems": [
      "Site preparation and excavation",
      "Structural construction",
      "Project management",
      "Demolition and reconstruction"
    ],
    "architecture": {
      "title": "Architecture Services",
      "description": "Innovative and sustainable architectural design services tailored to client needs and site conditions."
    },
    "architectureItems": [
      "Conceptual and detailed design",
      "3D modeling & rendering",
      "Space planning",
      "Permit drawings"
    ],
    "mechanical": {
      "title": "Mechanical Services",
      "description": "Mechanical engineering solutions for HVAC, plumbing, fire fighting, and energy efficiency."
    },
    "mechanicalItems": [
      "HVAC system design",
      "Plumbing design",
      "Fire protection systems",
      "Energy audits"
    ],
    "electrical": {
      "title": "Electrical Services",
      "description": "Electrical engineering services for residential, commercial, and industrial projects."
    },
    "electricalItems": [
      "Power distribution design",
      "Lighting systems",
      "Backup power systems",
      "Smart building integration"
    ]
  },




  "footer": {
    "companyName": "Turath Consultant",
    "companyDescription": "Expert consultancy in Electrical, Mechanical, Architecture, and Construction engineering. Turning visions into reality with innovation and professionalism.",
    "quickLinks": "Quick Links",
    "links": {
      "home": "Home",
      "about": "About",
      "services": "Services",
      "contact": "Contact"
    },
    "contactUs": "Contact Us",
    "address": "Al Muraba, Riyadh, Saudi Arabia",
    "phone": "011 4883449",
    "email": "info@turath-consultant.com",
    "rightsReserved": "All rights reserved."
  }


      },
    },
    ar: {
      translation: {
        nav: {
          home: "الرئيسية",
          about: "من نحن",
          services: "خدماتنا",
          contact: "اتصل بنا",
          language: "AR | EN",
        },
       
        hero:{
            title:"الحلول الهندسية في البناء والعمارة والميكانيكا والكهرباء"
        },

        inbox: {
    "location": "الموقع",
    "locationContent": "المرسلة، الرياض، المملكة العربية السعودية",
    "whatsapp": "واتساب",
    "whatsappContent": "+966582044542",
    "phone": "الهاتف",
    "phoneContent": "011 4883449"
  },



 about: {
    "sectionTitle": "من نحن؟",
    "companyName": "تراث للاستشارات | شريكك الموثوق في الهندسة والتصميم",
    "paragraph1": "تراث للاستشارات هي شركة رائدة في الاستشارات الهندسية المتعددة التخصصات مقرها الرياض. نحن متخصصون في تقديم حلول عالية الجودة في:",
    "servicesList": [
      "• الاستشارات الإنشائية",
      "• التصميم المعماري والإنشائي",
      "• الهندسة الميكانيكية والكهربائية (MEP)"
    ],
    "paragraph2": "نحن ملتزمون بالابتكار والجودة والدقة، وندعم العملاء من القطاع الخاص والمطورين العقاريين والمؤسسات الحكومية من الفكرة إلى التنفيذ.",
    "paragraph3": "فريقنا ذو الخبرة شغوف بإنشاء بيئات مستدامة وفعالة ورؤيوية تُشكل مستقبل الحياة الحديثة.",
    "feature1Title": "خبرة متعددة التخصصات",
    "feature1Subtitle": "المعماري، الإنشائي، الميكانيكي والكهربائي – كل ذلك تحت سقف واحد.",
    "feature2Title": "حلول تركز على العميل",
    "feature2Subtitle": "تصاميم مخصصة تمزج بين الابتكار والوظيفية والاستدامة.",
    "feature3Title": "رؤيتنا المستقبلية",
    "feature3Subtitle": "قيادة الابتكار والاستدامة لتشكيل مدن ذكية في المستقبل.",
    "stat1Label": "رضا العملاء",
    "stat2Label": "مشاريع مكتملة",
    "stat3Label": "سنوات من الخبرة"
  },


  services: {
    "title": "خدماتنا المتخصصة في الاستشارات الهندسية",
    "subtitle": "نقدم حلولاً هندسية متكاملة بمعايير دولية وخبرة محلية.",
    "button": "طلب خدمة",
    "construction": {
      "title": "خدمات الإنشاءات",
      "description": "نوفر حلول إنشاء متكاملة من التخطيط حتى التنفيذ وفقًا لمعايير الجودة والسلامة."
    },
    "constructionItems": [
      "تحضير الموقع والحفر",
      "البناء الإنشائي",
      "إدارة المشاريع",
      "الهدم وإعادة البناء"
    ],
    "architecture": {
      "title": "خدمات الهندسة المعمارية",
      "description": "تصميم معماري مبتكر ومستدام وفقًا لاحتياجات العميل وظروف الموقع."
    },
    "architectureItems": [
      "التصميم المفاهيمي والتفصيلي",
      "النمذجة ثلاثية الأبعاد والعرض",
      "تخطيط المساحات",
      "رسومات التراخيص"
    ],
    "mechanical": {
      "title": "الخدمات الميكانيكية",
      "description": "حلول هندسية ميكانيكية لأنظمة التكييف والسباكة والحماية من الحريق وكفاءة الطاقة."
    },
    "mechanicalItems": [
      "تصميم نظام التكييف والتهوية",
      "تصميم أنظمة السباكة",
      "أنظمة الحماية من الحريق",
      "تدقيقات كفاءة الطاقة"
    ],
    "electrical": {
      "title": "الخدمات الكهربائية",
      "description": "خدمات هندسة كهربائية للمشاريع السكنية والتجارية والصناعية."
    },
    "electricalItems": [
      "تصميم توزيع الطاقة",
      "أنظمة الإضاءة",
      "أنظمة الطاقة الاحتياطية",
      "دمج المباني الذكية"
    ]
  },



  "footer": {
    "companyName": "تراث للاستشارات",
    "companyDescription": "استشارات خبيرة في الهندسة الكهربائية والميكانيكية والهندسة المعمارية والبناء. تحويل الرؤى إلى واقع مع الابتكار والاحترافية.",
    "quickLinks": "روابط سريعة",
    "links": {
      "home": "الرئيسية",
      "about": "من نحن",
      "services": "الخدمات",
      "contact": "اتصل بنا"
    },
    "contactUs": "تواصل معنا",
    "address": "المربع، الرياض، المملكة العربية السعودية",
    "phone": "011 4883449",
    "email": "info@turath-consultant.com",
    "rightsReserved": "جميع الحقوق محفوظة."
  }

       
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
